import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { getInstitutionFailed, getInstitutionSuccess } from '../actions';
import { IstitutionActionTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';
import { setOrgRoutingKeys } from 'utils/portalSlug';

const { API_BASE_URL } = urls || {};

export function* fetchInstitutionInfo() {
  const url = `${API_BASE_URL}/organisation`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    const org = response.raw || {};
    const canonicalId = org.id || '';
    const portalAlias = org.portalAlias || canonicalId;
    setOrgRoutingKeys(canonicalId, portalAlias);
    yield put(
      getInstitutionSuccess({
        ...org,
        portalAlias,
      })
    );
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Portal: ${response.message}`);
    yield put(getInstitutionFailed(response.message));
  }
}

export function* getInstitutionInfo() {
  yield takeEvery(IstitutionActionTypes.GET_INSTITUTION, fetchInstitutionInfo);
}
